import axios from "axios";
import React from "react";
import { getApiUrl } from "../../../utils/baseUrl";
import { globalGetApiUrl } from "../../../utils/globalBaseUrl";

const apiUrls = {
  requestDemoAPIUrl: getApiUrl("requestDemo"),
  profile: globalGetApiUrl("auth/getUserProfileComplete"),
};
export class ThankyouPage extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    languageUrl: this.props.language === "" || this.props.language === "en" ? "" : this.props.language + "/",
    advancedYearly: true,
    advancedID: "annually",
    userDetails: "",
  };

  render() {
    return (
      <React.Fragment>
        <div className="thankyou_page">
          <div className="d-flex justify-content-center thankyou_img_container">
            <img className="thankyou_img" src="https://res.cloudinary.com/drzta9shk/image/upload/v1670836842/website/Pricing%20Page/Sent_Message-rafiki_1_ia4zpp.svg" />
          </div>
          <div className="d-flex justify-content-center thankyou_content_container">
            <div className="thankyou_content">Thank you for the request. Our customer success representative will connect with you shortly.</div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ThankyouPage;
